import React, { useState } from 'react';

import { LogoutButton } from '../Auth';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

interface UserMenuProps {
  isPremium?: boolean;
  remainingBookings?: number;
  onResetPassword?: () => void;
  onDeleteAccount?: () => void;
}

/**
 * Dropdown displayed when the user clicks their profile picture.
 * Shows membership information and account actions.
 */
const UserMenu: React.FC<UserMenuProps> = ({
  isPremium = false,
  remainingBookings = 0,
  onResetPassword,
  onDeleteAccount,
}) => {
  const membership = isPremium ? 'Premium' : 'Standard';
  const [info, setInfo] = useState<string | null>(null);

  const handleReset = () => {
    if (onResetPassword) onResetPassword();
    else setInfo('Password reset not implemented yet.');
  };

  const handleDelete = () => {
    if (onDeleteAccount) onDeleteAccount();
    else setInfo('Account deletion not implemented yet.');
  };

  return (
    <div className='space-y-2 text-sm text-gray-700'>
      <div>
        <div className='font-medium'>Mitgliedschaft: {membership}</div>
        <div className='text-xs text-gray-500'>
          Verbleibende Buchungen: {remainingBookings}
        </div>
      </div>
      <hr className='border-gray-300' />
      <button
        type='button'
        onClick={handleReset}
        className='w-full px-3 py-2 text-left rounded hover:bg-gray-200'
      >
        Passwort zurücksetzen
      </button>
      <button
        type='button'
        onClick={handleDelete}
        className='w-full px-3 py-2 text-left text-red-600 rounded hover:bg-red-50'
      >
        Konto löschen
      </button>
      <LogoutButton />
      <ConfirmModal
        isOpen={info !== null}
        title='Info'
        message={info || ''}
        hideCancel
        onConfirm={() => setInfo(null)}
        onCancel={() => setInfo(null)}
      />
    </div>
  );
};

export default UserMenu;
